/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendPromptResponse
 */
export interface SendPromptResponse {
    /**
     * 
     * @type {string}
     * @memberof SendPromptResponse
     */
    promptRefId: string;
}

/**
 * Check if a given object implements the SendPromptResponse interface.
 */
export function instanceOfSendPromptResponse(value: object): value is SendPromptResponse {
    if (!('promptRefId' in value) || value['promptRefId'] === undefined) return false;
    return true;
}

export function SendPromptResponseFromJSON(json: any): SendPromptResponse {
    return SendPromptResponseFromJSONTyped(json, false);
}

export function SendPromptResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendPromptResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'promptRefId': json['promptRefId'],
    };
}

export function SendPromptResponseToJSON(json: any): SendPromptResponse {
    return SendPromptResponseToJSONTyped(json, false);
}

export function SendPromptResponseToJSONTyped(value?: SendPromptResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'promptRefId': value['promptRefId'],
    };
}

